import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'
import { notifyBugsnag, selectSystemData } from '../helpers'

export const useSystemQuery = ({ username }) => {
  return useQuery({
    queryKey: QUERY_KEYS.system,
    queryFn: () => {
      return Promise.all(
        [
          'CURRENT_CHALLENGE_CONFIG_ID',
          'MAIL_TEMPLATES',
          'CHALLENGES',
          'CATEGORIES',
          'DIMENSIONS',
          'DIMENSIONS_PDF_REPORTS',
          'DIMENSIONS_CULTURE',
          'ANNOUNCEMENT'
        ].map((id) => query({ query: 'getSystem', variables: { id } }))
      )
    },
    select: (items) => {
      try {
        return selectSystemData(items)
      } catch (err) {
        notifyBugsnag(err)
      }
    },
    enabled: !!username
  })
}
